const indexItems = [
  { emoji: '🔥', title: '韩漫热门连载', desc: '《我独自升级》《浪漫满屋》《她的私生活》等热门韩漫下拉式全集', count: '48部' },
  { emoji: '💕', title: '恋爱甜漫合集', desc: '《社内相亲》《女神降临》等甜到牙疼的韩漫恋爱下拉式免费全集', count: '62部' },
  { emoji: '⚔️', title: '奇幻战斗专题', desc: '热血战斗、异世界穿越类韩漫下拉式全集，爽感拉满', count: '35部' },
  { emoji: '🇯🇵', title: '日漫经典专区', desc: '《鬼灭之刃》《间谍过家家》等经典日漫下拉式免费阅读', count: '56部' },
  { emoji: '🏫', title: '校园青春漫画', desc: '校园恋爱、成长故事等青春题材漫画下拉式全集', count: '41部' },
  { emoji: '✨', title: '穿越重生精选', desc: '《某天成为公主》等穿越重生类韩漫下拉式完整收录', count: '29部' },
  { emoji: '🆕', title: '本周新番速递', desc: '最新上线的韩漫日漫下拉式作品一览，追新不迷路', count: '12部' },
  { emoji: '🏆', title: '完结经典必刷', desc: '已完结的高分漫画下拉式全集，适合一口气刷完', count: '73部' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">专题合集</h2>
          <p className="text-sm text-foreground-500 mt-2">女神漫画下拉式内容分类索引，快速找到你爱的类型</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indexItems.map((item, i) => (
            <div
              key={i}
              className="group cursor-pointer p-5 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-200"
            >
              <div className="flex items-start gap-3">
                <span className="text-2xl flex-shrink-0">{item.emoji}</span>
                <div className="min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <h3 className="text-sm font-heading text-foreground-800 group-hover:text-primary-500 transition-colors">
                      {item.title}
                    </h3>
                    <span className="text-[11px] px-1.5 py-0.5 rounded bg-accent-100 text-accent-700 font-medium whitespace-nowrap">
                      {item.count}
                    </span>
                  </div>
                  <p className="text-xs text-foreground-500 mt-1.5 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}